import React from 'react';

export const PointsIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_203_1259)">
        <path
          d="M27.4267 10.8835C27.6236 10.351 28.3768 10.351 28.5737 10.8835C30.7722 16.8245 31.8714 19.795 34.0384 21.9619C36.2051 24.1288 39.1757 25.228 45.1166 27.4265C45.6491 27.6234 45.6491 28.3766 45.1166 28.5735C39.1757 30.772 36.2051 31.8712 34.0384 34.0382C31.8714 36.2049 30.7722 39.1755 28.5737 45.1164C28.3768 45.6489 27.6236 45.6489 27.4267 45.1164C25.2282 39.1755 24.129 36.2049 21.9621 34.0382C19.7952 31.8712 16.8247 30.772 10.8838 28.5735C10.3512 28.3766 10.3512 27.6234 10.8838 27.4265C16.8247 25.228 19.7952 24.1288 21.9621 21.9619C24.129 19.795 25.2282 16.8245 27.4267 10.8835Z"
          fill="#F5E7BA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_203_1259"
          x="-3.51562"
          y="-3.51584"
          width="63.0317"
          height="63.0316"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.959936 0 0 0 0 0.90599 0 0 0 0 0.728115 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_203_1259" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_203_1259" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
